module.exports = "/_next/static/images/ms-icon-144x144-600ec7d419289241e69d3a2b1a84de44.png";